/**
* pageView.ts
* @author Ram Thiru (ramthi) and Hector Hernandez (hectorh)
* @copyright Microsoft 2018
*/
import { __extends } from "tslib";
import { isValueAssigned, safeGetCookieMgr } from "@microsoft/applicationinsights-core-js";
import { _getCookies } from "../DataCollector";
import { WebEvent } from "./WebEvent";
var PageView = /** @class */ (function (_super) {
    __extends(PageView, _super);
    function PageView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
      * API to populate and send a PageView event
      * @param overrideValues - PageView overrides
      * @param customProperties - Custom properties(Part C)
      */
    PageView.prototype.capturePageView = function (overrideValues, customProperties) {
        overrideValues = !isValueAssigned(overrideValues) ? {} : overrideValues;
        var pageViewEvent = {};
        var properties = isValueAssigned(customProperties) ? customProperties : {};
        this._setCommonProperties(pageViewEvent, properties, overrideValues);
        // Add pageView fields
        pageViewEvent.refUri = isValueAssigned(overrideValues.referrerUri) ? overrideValues.referrerUri : this._config.coreData.referrerUri;
        pageViewEvent.isManual = !overrideValues.isAuto;
        var cookieMgr = this._webAnalyticsPlugin.core && safeGetCookieMgr(this._webAnalyticsPlugin.core);
        var cookiesValue = _getCookies(this._config, cookieMgr, this._traceLogger);
        if (cookiesValue) {
            properties.cookies = cookiesValue;
        }
        properties.behavior = this._getBehavior(overrideValues);
        this._webAnalyticsPlugin.trackPageView(pageViewEvent, properties);
    };
    return PageView;
}(WebEvent));
export { PageView };
//# sourceMappingURL=PageView.js.map